import React from 'react';
import data from '../../legal-content/privacy.json';
import LegalDocument from '../../components/LegalDocument/LegalDocument';

const PrivacyPolicyPage = () => <LegalDocument data={data} currentPage="PrivacyPolicyPage" />;

export default PrivacyPolicyPage;
